// SPDX-License-Identifier: Apache-2.0

import PerunMessage from "./PerunMessage";
import { MessageType, MessageTypeName } from "./messageTypes";
import { jsonArrayMember, jsonObject } from "typedjson";
import StellarAsset from "./types/stellarAsset";
import EthereumAsset from "./types/ethereumAsset";
import { NervosAsset } from "./types/nervosAsset";

@jsonObject
export default class GetAssetsResponse extends PerunMessage {
  @jsonArrayMember(EthereumAsset) ethereumAssets: EthereumAsset[];
  @jsonArrayMember(StellarAsset) stellarAssets: StellarAsset[];
  @jsonArrayMember(NervosAsset) nervosAssets: NervosAsset[];

  constructor(
    stellarAssets: StellarAsset[],
    ethereumAssets: EthereumAsset[],
    nervosAssets: NervosAsset[],
  ) {
    super();
    this.stellarAssets = stellarAssets;
    this.ethereumAssets = ethereumAssets;
    this.nervosAssets = nervosAssets;
  }

  messageType(): MessageType {
    return GetAssetsResponse;
  }

  messageTypeName(): MessageTypeName {
    return "GetAssetsResponse";
  }
}
